import Api from './Api';

const Houses = () => {
  return Api().get('/houses');
};

const House = (id) => {
  return Api().get(`/houses/${id}`);
};

const AddHouse = (data) => {
  return Api().post('/houses', data);
};

const EditHouse = (id, data) => {
  return Api().put(`/houses/${id}`, data);
};

const RemoveHouse = (id) => {
  return Api().delete(`/houses/${id}`);
};

export { Houses, House, AddHouse, EditHouse, RemoveHouse };
